module.exports = __webpack_public_path__ + "img/solution--easy-patient-transportation.d3c08485.jpg";